import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import React, { ReactNode } from 'react';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { withRouter } from 'react-router';
import { CreditComponentView, cardYearPlaceHolder } from './CreditComponentView';
import { WprInput } from '../../wpr-framework/component/controls/WprInput';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprSelect } from '../../wpr-framework/component/controls/WprSelect';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { WprViewError } from '../../wpr-framework/component/controls/WprViewError';
import ccimage from '../../../public/images/icons/ccimage.png';
import ico_visa from '../../../public/images/icons/ico_visa.png';
import ico_mastercard from '../../../public/images/icons/ico_mastercard.png';
import ico_jcb from '../../../public/images/icons/ico_jcb.gif';
import ico_americanexpress from '.../../../public/images/icons/ico_americanexpress.gif';
import ico_diners from '../../../public/images/icons/ico_diners.gif';

/**
 * クレジット払いコンポーネント
 */
class CreditComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new CreditComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>5</span></li>
								<li className="done"><span>6</span></li>
								<li className="now">
									<span>7</span>
									<p className="conf" id="step7">保険料のお支払い</p>
								</li>
								<li><span>8</span></li>
							</ul>
						</div>
					</div>
				</div>
				<main className="page-credit-insert">
					<div className="top">
						<h1>クレジットカードの情報を入力してください</h1>
					</div>
					<section className="credit">
						<h2 className="c-headline">クレジットカード払い</h2>
						<div className="insert">
							<div className="ico">
								<img src={ico_visa} alt="VISA" />
								<img src={ico_mastercard} alt="MASTER" />
								<img src={ico_jcb} alt="JCB" />
								<img src={ico_americanexpress} alt="American Express" />
								<img src={ico_diners} alt="DINERS" />
							</div>
							<dl>
								<dt>カード番号</dt>
								<dd className="c-input">
									<WprInput view={this.view} name="cardNo" type="text" placeholder="例） 1234567812345678" id="id-card_no"/>
								</dd>
								<WprViewError view={this.view} name="cardNo" dispMax={1} className="c-errmsg" />
							</dl>
							<dl>
								<dt>カード名義<span style={{fontSize: '0.8rem', fontWeight: 'normal', marginLeft: '20px'}}>必ず保険契約者ご本人名義のクレジットカードをご利用ください。</span></dt>
								<dd className="c-input">
									<WprInput view={this.view} name="cardName" type="text" placeholder="例） TARO SUISU" id="id-card_name"/>
								</dd>
								<WprViewError view={this.view} name="cardName" className="c-errmsg" />
							</dl>
							<dl className="limit">
								<dt>有効期限</dt>
								<dd className="c-input">
									<div className="month">
										<div className="c-select">
											<div>
												<WprSelect view={this.view} name="cardMonth" vm="cc-exp-month" placeholder="例）01"></WprSelect>
											</div>                    
										</div>
                                        
									</div>
									<div className="year">
										<div className="c-select">
											<span>／</span>
											<div>
												<WprSelect view={this.view} name="cardYear" vm="cc-exp-year" placeholder={this.setYearPlaceHolder()}></WprSelect>
											</div>
										</div>
									</div>
								</dd>
								<WprViewError view={this.view} name="cardYear, cardMonth" dispMax={1} className="c-errmsg" />
							</dl>
							<dl className="security">
								<dt>
									<span>セキュリティコード</span>
									<WprButton view={this.view} name="aboutSC" className="c-quest-b" ></WprButton>
								</dt>
								<dd className="c-input">
									<WprInput view={this.view} name="cardRimit" type="password" placeholder="例）123" id="id-card_rimit"/>
								</dd>
								<WprViewError view={this.view} name="cardRimit" dispMax={1} className="c-errmsg" />
							</dl>
						</div>
						<div className="sum">
							<dl>
								<dt>保険料（全員分）</dt>
								<dd><WprSpan view={this.view} name="insuranceFee" converter="3桁カンマ"></WprSpan>円</dd>
							</dl>
						</div>
						<WprButton view={this.view} name="creditSettleButton" className="c-button"><span>決済して締結する</span></WprButton>
					</section>
					<section className="annotation">
						<p>
							・必ず、保険契約者ご本人名義のクレジットカードをご利用ください。<br />
							・お支払い方法は一括払いのみとなります。<br />
							・クレジットカード決済日は、ご指定いただいたクレジットカード会員規約によります。
						</p>
					</section>
					<WprContainer view={this.view} mode="avoutSCModal.表示">
						<div className="c-layer">
							<div className="box">
								<h1>セキュリティコードとは</h1>
								<p>クレジットカードの記載の3桁、または4桁の数字を入力してください。
									<br />記載箇所はカードによって異なりますので下記イラストを参照ください。
								</p>
								<p style={{textAlign: 'center'}}><img src={ccimage} alt="VISA" /></p>
								<WprButton view={this.view} name="closeSCButton" className="button"><span>閉じる</span></WprButton>
							</div>
						</div>
					</WprContainer>
				</main>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------

	private setYearPlaceHolder() {
		return cardYearPlaceHolder;
	}
}

export default withRouter(CreditComponent);